import React, { useEffect, useState } from 'react';
import BadgesPool from '../../js/BadgesPool';
import SGMSClient from '../../js/SGMSClient';
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import { store } from '../../stores/store';
import Badge from './Badge/Badge';
import Leaderboard from './Leaderboard/Leaderboard';
import MyScores from './MyScores/MyScores';
import './ProfilePopup.css';


const ProfilePopup = ({data}) => {
  // const [state, setState] = useState(null);

  const [tab, setTab] = useState(0);

  useEffect(() => {
    return () => BadgesPool.unNotify()
  }, []);



  function onClose() {
    PopupStore.close(POPUPS_IDS.PROFILE)
  }


  let pseudo = SGMSClient.currentUser.UserPseudo

  return (
    <div className="overlay" onClick={onClose}>
      <div className="ProfilePopup"  onClick={(e)=>{e.stopPropagation()}}>
        <div className="ProfilePopup-title">

          {store.t("profile_popup_title", "Profile")} {pseudo && <span>- {pseudo}</span>}

        </div>

        <div className="ProfilePopup-tabs">
          <div className={"Tab" + (tab === 0 ? " selected" : "")} onClick={()=>setTab(0)}>{store.t("badges_tab")}</div>
          <div className={"Tab" + (tab === 1 ? " selected" : "")} onClick={()=>setTab(1)}>{store.t("score_tab")}</div>
          <div className={"Tab" + (tab === 2 ? " selected" : "")} onClick={()=>setTab(2)}>{store.t("leaderboard_tab")}</div>
        </div>

        <div className="ProfilePopup-content">

          {tab === 0 && <div className="badges">
            {BadgesPool.sorted
            // .filter(b => b.isActive)
            .map(badge => <Badge data={badge} key={badge.id} />)}
          </div>}
          {tab === 1 && <MyScores />}

          {tab === 2 && <div className="leaderboard">
            <Leaderboard />
          </div>}


        </div>
      </div>
    </div>
  );
};

export default ProfilePopup;
